import police from "../images/university/WSPol.png";
import war from "../images/university/warstudies.png";
import dci from "../images/university/dci.png";
import edu from "../images/university/edu3.png";

export const Education = ({ educationRef }) => {
    const policeIcon = police;
    const warIcon = war;
    const dciIcon = dci;
    const eduIcon = edu;

    const education = [
        {
            date: "2022-2024",
            title: "Full Stack Web Development Course",
            university: "Digital Career Institute GmbH",
            knowledge: [
                "Acquired proficiency in administering servers, managing databases (MySQL, NoSQL), deploying, and scaling applications.",
                "Developed responsive, scalable, and dynamic websites using React and Vanilla JS.",
                "Proficient in Git for efficient code versioning and collaboration.",
                "Knowledge of OOP and functional programming concepts.",
                "Adaptable and quick learner, capable of adjusting to changing work environments and technologies.",
                "Mastered DOM manipulation, HTTP requests, and implemented efficient Single Page Applications (SPAs) using React.",
                "Enhanced soft skills, including effective communication, presentation, teamwork, and time management.",
            ],
            image: dciIcon,
        },
        {
            date: "2018-2020",
            title: "Master of State Defence",
            university: "War Studies Academy, Warsaw",
            knowledge: [
                "Cybersecurity awareness",
                "Crisis Management",
                "Emphasized ability to analyze complex situations and make critical decisions",
                "Improved interpersonal abilities, including proficient communication",
                "Communication Skills in Russian (A1)",
            ],
            image: warIcon,
        },
        {
            date: "2015-2018",
            title: "Bachelor of Criminology",
            university: "Police Academy, Szczytno",
            knowledge: [
                "Expanded research and analytical skills",
                "Collecting, storing, organizing and analyzing data",
                "Legal and regulatory awareness",
                "Developed ability to work effectively in teams",
                "Progressed in conflict resolution skills, which can be beneficial for resolving disagreements",
                "Fluent in communication in English (C1)",
            ],
            image: policeIcon,
        },
    ];
    return (
        <div className="Education" ref={educationRef}>
            <img src={eduIcon} alt="education" className="EducationIcon" />
            <div className="Education-Box-Name">Education</div>

            <div className="Education-Box-Text">
                {education.map((education, index) => (
                    <div key={index} className="Education-Box-Text-Item">
                        <div className="Education-Box-Text-Item-Image">
                            <img
                                src={education.image}
                                alt="University Logo"
                                className="Education-Box-Text-Item-Image-Icon"
                            />
                        </div>
                        <div className="Education-Box-Text-Item-Sub">
                            <div className="Education-Box-Text-Item-Date">
                                {education.date}
                            </div>
                            <div className="Education-Box-Text-Item-Title">
                                {education.title}
                            </div>
                            <div className="Education-Box-Text-Item-University">
                                {education.university}
                            </div>
                        </div>
                        <div className="Education-Box-Text-Item-Knowledge">
                            {education.knowledge.map((knowledge, index) => (
                                <li
                                    key={index}
                                    className="Education-Box-Text-Item-Knowledge-Item"
                                >
                                    {`💠 ${knowledge}`}
                                </li>
                            ))}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};
